<template>
  <v-app-bar flat class="app-toolbar">
    <v-container class="d-flex align-center">
      <v-app-bar-nav-icon v-if="showNavIcon" variant="text" @click.stop="toggleDrawer()" />
      <h2 class="app-toolbar__title">{{ pageName }}</h2>

      <v-spacer />

      <v-menu v-model="menu" :close-on-content-click="false">
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" prepend-icon="mdi-account" variant="flat" class="ml-2 text-none text-white" color="secondary">{{ getUserName() }}</v-btn>
        </template>

        <v-list>
          <v-list-item v-if="['professor', 'coordenador'].includes($store.state.userType)" prepend-icon="mdi-home" title="Início" :to="'/Painel'" />
          <v-divider class="my-2" />
          <v-list-group value="Pessoal">
            <template v-slot:activator="{ props }">
              <v-list-item v-bind="props" prepend-icon="mdi-account" title="Pessoal" />
            </template>
            <v-list-item v-for="([title, value, icon], i) in pessoal" :key="i" :title="title" :value="value" :to="value"
              :prepend-icon="icon" />
          </v-list-group>
          <v-divider class="my-2" />

          <template v-if="['professor', 'coordenador'].includes($store.state.userType)">
            <v-list-group value="TBL">
              <template v-slot:activator="{ props }">
                <v-list-item v-bind="props" prepend-icon="mdi-account-group" title="TBL" />
              </template>
              <v-list-item v-for="([title, value, icon], i) in tbl" :key="i" :title="title" :value="value" :to="value"
                :prepend-icon="icon" />
            </v-list-group>
            <v-divider class="my-2" />
            <v-list-group value="Avaliação Discursiva">
              <template v-slot:activator="{ props }">
                <v-list-item v-bind="props" prepend-icon="mdi-text-box-edit" title="Avaliação Discursiva" />
              </template>
              <v-list-item v-for="([title, value, icon], i) in avaliacaoDiscursivaItems" :key="i" :title="title" :value="value"
                :to="value" :prepend-icon="icon" />
            </v-list-group>
            <v-divider class="my-2" />
            <v-list-group value="OSCE">
              <template v-slot:activator="{ props }">
                <v-list-item v-bind="props" prepend-icon="mdi-clipboard-check" title="OSCE" />
              </template>
              <v-list-item v-for="([title, value, icon], i) in osceProf" :key="i" :title="title" :value="value"
                :to="value" :prepend-icon="icon" />
            </v-list-group>
          </template>

          <template v-if="['professor', 'coordenador', 'admin', 'administrador_sistema'].includes($store.state.userType)">
            <v-divider class="my-2" />
            <v-list-group value="Estatística da Turma">
              <template v-slot:activator="{ props }">
                <v-list-item v-bind="props" prepend-icon="mdi-chart-box" title="Estatística da Turma" />
              </template>
              <v-list-item v-for="([title, value, icon], i) in estatisticaTurmaProf" :key="i" :title="title" :value="value"
                :to="value" :prepend-icon="icon" />
            </v-list-group>
          </template>

          <template v-if="['administrador_sistema', 'admin'].includes($store.state.userType)">
            <v-divider class="my-2" />
            <v-list-item prepend-icon="mdi-account-cog" title="Administração" :to="'/AdminSistema'" />
          </template>

          <template v-if="$store.state.userType === 'aluno'">
            <v-list-item prepend-icon="mdi-view-dashboard" title="Dashboard Acadêmico" :to="'/Aluno/Dashboard'" />
            <v-divider class="my-2" />
            <v-list-group value="TBL">
              <template v-slot:activator="{ props }">
                <v-list-item v-bind="props" prepend-icon="mdi-chair-school" title="TBL" />
              </template>
              <v-list-item v-for="([title, value, icon], i) in salaAula" :key="i" :title="title" :value="value"
                :to="value" :prepend-icon="icon" />
            </v-list-group>
            <v-divider class="my-2" />
            <v-list-group value="Avaliação Discursiva">
              <template v-slot:activator="{ props }">
                <v-list-item v-bind="props" prepend-icon="mdi-text-box-edit" title="Avaliação Discursiva" />
              </template>
              <v-list-item v-for="([title, value, icon], i) in avaliacaoDiscursivaAluno" :key="i" :title="title" :value="value"
                :to="value" :prepend-icon="icon" />
            </v-list-group>
            <v-divider class="my-2" />
            <v-list-group value="OSCE">
              <template v-slot:activator="{ props }">
                <v-list-item v-bind="props" prepend-icon="mdi-clipboard-check" title="OSCE" />
              </template>
              <v-list-item v-for="([title, value, icon], i) in osceAluno" :key="i" :title="title" :value="value"
                :to="value" :prepend-icon="icon" />
            </v-list-group>
          </template>

          <v-divider class="my-2" />
          <v-list-item prepend-icon="mdi-logout" title="Sair" @click="logout()" />
        </v-list>
      </v-menu>
    </v-container>
  </v-app-bar>

  <v-dialog v-model="showLogoutConfirm" max-width="400">
    <v-card prepend-icon="mdi-logout" title="Sair do sistema">
      <v-card-text>
        Tem certeza que deseja sair?
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" @click="showLogoutConfirm = false">Cancelar</v-btn>
        <v-btn color="error" variant="flat" @click="confirmLogout">Sair</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script src="@/assets/js/bar.js" />

<style scoped>
.app-toolbar {
  margin: 18px 24px 0;
  border: 1px solid var(--pcse-border);
  border-radius: 22px;
  background: var(--pcse-topbar-bg) !important;
  backdrop-filter: blur(10px);
}

.app-toolbar__title {
  color: var(--pcse-text-main);
  font-weight: 700;
  letter-spacing: 0.01em;
}

@media (max-width: 600px) {
  .app-toolbar {
    margin: 8px 8px 0;
    border-radius: 14px;
  }

  .app-toolbar__title {
    font-size: 1rem;
    max-width: 48vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
